<div class="hover" #hover  [ngClass]="{'bottom':isBottom}"  *ngIf="(recipients?.groups!=undefined && recipients?.groups?.length??0 >0 ) else noGroups">
    <div class="sendTo"> 
        <img class="group-img" src="/assets/images/grid/group.svg">
        <div class="group" [ngClass]="{'min-content':recipients?.users?.length!=0}">
            <ng-container *ngFor="let group of recipients?.groups,let i = index">
                {{group.name}}
                <ng-container *ngIf="recipients?.groups?.length!=i+1">,</ng-container>
            </ng-container>
        </div>
        <div class="plus" *ngIf="recipients?.users?.length!=0">
            <p>+</p>
            <p>{{recipients?.users?.length}}</p>
            <!-- *ngIf=" questionnaire?.recipients?.groups?.length!=0" -->
        </div>
    </div>
    <div class="warp-tooltip">
        <div class="realative">
            <que-contact-tooltip *ngIf="recipients?.users || recipients?.groups" class="tooltip trans50" [color]="'#B7C7FC'"
                [recipients]="recipients?.users" [groups]="recipients?.groups" [title]="title" [isBottom]="isBottom"></que-contact-tooltip>
        </div>
    </div>
</div>

<ng-template #noGroups>
    <div *ngIf="users?.length!=0 && users?.length!=undefined" class="warp-recipient" #hover>
        <div class="hover "  [ngClass]="{'bottom':isBottom}">
            <que-recipients-display [recipients]="users" [isStatusReply]="false" [userCounts]="userCounts"></que-recipients-display>
            <div class="warp-tooltip">
                <que-contact-tooltip  *ngIf="recipients?.users" class="tooltip trans50" [color]="'#B7C7FC'" 
                    [recipients]="uniqeRecipient" [isBottom]="isBottom" [title]="title"></que-contact-tooltip>
            </div>
        </div>
    </div>
</ng-template>